import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

export default function registerStageSortable(Alpine) {
  Alpine.data("stageSortable", () => ({
    sortable: null,

    init() {
      this.$nextTick(() => this.setup());
    },

    setup() {
      if (this.sortable) this.sortable.destroy();

      const list = this.$refs.stageList;
      if (!list) return;

      this.sortable = Sortable.create(list, {
        animation: 150,
        handle: "[data-drag-handle]",
        ghostClass: "opacity-30",
        dragClass: "shadow-2xl",
        onEnd: () => this.persist()
      });
    },

    async persist() {
      const list = this.$refs.stageList;
      const ids = [...list.querySelectorAll("[data-stage-id]")].map((el) => el.dataset.stageId);

      const url = list.dataset.reorderUrl;

      // Update position numbers in the UI
      list.querySelectorAll("[data-stage-id]").forEach((el, i) => {
        const posEl = el.querySelector("[data-position]");
        if (posEl) posEl.textContent = i + 1;
      });

      await patch(url, {
        body: JSON.stringify({ stage_ids: ids }),
        contentType: "application/json",
        responseKind: "json"
      });
    }
  }));
}
